
import { MdMoreVert } from "react-icons/md";



const AuduitItem = (props:any) => (
  <div className="w-full border text-xs font-light flex justify-between  items-center border-gray-300 rounded-[10px] p-3 my-2 ">

    <p className="text-xs">
        {props.item.user.email}
    </p>

    <p className={`p-1 text-[10px] `}>
        {props.item.action}
    </p>

    <p className={`text-xs text-[10px] p-1 rounded ${props.item.status.toLowerCase().includes("success")?" bg-faintBlue":"bg-red-100"} `}>
        {props.item.status}
    </p>
    <p className="text-xs w-[24%] truncate" >
        {props.item.updatedAt}
    </p>

    <MdMoreVert className="inline "/>
  </div>
);

export { AuduitItem };
